import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { SignatureReducer } from 'app/reducers/SignatureReducer';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../SignatureScreenStyles';
import * as SignatureActions from "app/actions/SignatureActions";
import { employeeById } from 'app/reducers';

const FilterScreen = (props) => {
    const classes = useStyles();
    const [collapse, setCollapse] = useState(true);
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    const {
        isLoadingSignature,
        isDeleting,
        isSaving,
        listContrat,
        listCategory,
        filters,
        pagination
    } = useSelector(state => state.SignatureReducer);

    const data = {
        Offset: 0,
        Limit: pagination.pageSize,
        sortColumn: pagination.column,
        sortDir: pagination.order,
        EmployeeId: props.FilterContracts.join(','),
        IdCategory: props.FilterCategories.join(','),
    }


    const onSelectContract = (contracts) => {
        props.setSelectedContracts(contracts);
    }

    const onSelectCategory = (categories) => {
        props.setSelectedCategory(categories);
    }


    const search = () => {
        dispatch(SignatureActions.getListSignatures(data))
    }

    const exportXls = () => {

    }

    const optionCategory = filters.IdCategory.map((item) =>
        <Select.Option key={item.idCategory} value={item.idCategory}>{item.categoryName}</Select.Option>
    );

    const optionEmployee = filters.EmployeeId.map((item) =>
        <Select.Option key={item.employeeId} value={item.employeeId}>{item.employeeName}</Select.Option>
    );

    // const optionKeyuser = listKeyUser.map((item) =>
    //     (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    // );

    // const optionFunctional = listFunctional.map((item) =>
    //     (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    // );

    return (
        <div>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Nombre:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            placeholder="[Selecionar Nombre]"
                            showSearch
                            value={props.FilterContracts}
                            onChange={onSelectContract}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionEmployee}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Contratos:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            placeholder="[Selecionar KeyUser]"
                            showSearch
                            value={props.FilterCategories}
                            onChange={onSelectCategory}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionCategory}
                        </Select>
                    </Grid>
                </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }

                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    loading={isLoadingSignature}
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                {/* <Button
                    className={classes.button}
                    // loading={isLoadExport}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button> */}
                {
                    siteId === "HUB" ?
                        <Button
                            className={classes.button}
                            variant="contained"
                            type="primary"
                            onClick={props.newSignature}
                        >
                            Nuevo
                        </Button> : null
                }
            </div>
        </div>
    );
}

export default FilterScreen;
